<template>
  <div
    v-if="!(!!currentVariation.filter && currentVariation.filter.isSalable)"
    class="availability-form-container my-3"
  >
    <form
      class="form-main"
      method="post"
      :id="'ask-question-avability-form_' + _uid"
      @submit.prevent="validateData"
    >
      <div class="icon">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6952_963)">
            <path
              d="M6.23628 14C6.70637 14.4149 7.32387 14.6666 8.00017 14.6666C8.67646 14.6666 9.29396 14.4149 9.76405 14M1.52943 3.87991C1.51986 2.91234 2.04152 2.00881 2.88423 1.53331M14.4683 3.87991C14.4778 2.91235 13.9562 2.00881 13.1134 1.53332M12.0002 5.33331C12.0002 4.27245 11.5787 3.25503 10.8286 2.50489C10.0784 1.75474 9.06103 1.33331 8.00017 1.33331C6.9393 1.33331 5.92188 1.75474 5.17174 2.50489C4.42159 3.25503 4.00017 4.27245 4.00017 5.33331C4.00017 7.39344 3.48048 8.80395 2.89994 9.73692C2.41025 10.5239 2.1654 10.9174 2.17438 11.0272C2.18432 11.1487 2.21007 11.195 2.30802 11.2677C2.39647 11.3333 2.79523 11.3333 3.59274 11.3333H12.4076C13.2051 11.3333 13.6039 11.3333 13.6923 11.2677C13.7903 11.195 13.816 11.1487 13.8259 11.0272C13.8349 10.9174 13.5901 10.5239 13.1004 9.73692C12.5199 8.80395 12.0002 7.39344 12.0002 5.33331Z"
              stroke="white"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_6952_963">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <p class="h3" v-html="multiLanguage.AvailabilityTitle"></p>
      <p class="small text-muted my-3 my-md-2">
        {{ multiLanguage.AvailabilityText }}
      </p>
      <div>
        <div class="form-input" data-validate="mail">
          <label :for="'email-input_' + _uid">
            {{ multiLanguage.ContactEmail }}
          </label>
          <input
            type="email"
            :id="'email-input_' + _uid"
            v-model="email"
            :placeholder="multiLanguage.ContactEmailPlaceholder"
            name="email"
          />
          <span class="error-feedback">
            {{ multiLanguage.EmailFieldRequired }}
          </span>
        </div>
        <div class="form-input" data-validate="regex">
          <label :for="'phone-input_' + _uid">
            {{ multiLanguage.ContactNumber }}
          </label>
          <input
            type="text"
            :id="'phone-input_' + _uid"
            v-model="phone"
            data-validate-ref="/(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/"
            :placeholder="multiLanguage.ContactNumberPlaceholder"
            name="phone"
          />
          <span class="error-feedback">
            {{ multiLanguage.PhoneNumberFieldRequired }}
          </span>
        </div>
      </div>
      <button
        class="btn btn-block btn-primary w-full mt-3"
        type="submit"
        @click="validateData"
        :disabled="isDisabled"
        v-tooltip
        data-toggle="tooltip"
        data-placement="top"
        :title="tooltipText"
      >
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6952_954)">
            <path
              d="M6.31148 14.77C6.78157 15.1849 7.39906 15.4367 8.07536 15.4367C8.75166 15.4367 9.36916 15.1849 9.83924 14.77M1.60462 4.64993C1.59506 3.68236 2.11671 2.77883 2.95943 2.30333M14.5435 4.64993C14.553 3.68237 14.0314 2.77883 13.1886 2.30333M12.0754 6.10333C12.0754 5.04247 11.6539 4.02505 10.9038 3.27491C10.1536 2.52476 9.13623 2.10333 8.07536 2.10333C7.0145 2.10333 5.99708 2.52476 5.24693 3.27491C4.49679 4.02505 4.07536 5.04247 4.07536 6.10333C4.07536 8.16346 3.55567 9.57397 2.97514 10.5069C2.48545 11.2939 2.2406 11.6874 2.24958 11.7972C2.25952 11.9187 2.28527 11.9651 2.38321 12.0377C2.47167 12.1033 2.87042 12.1033 3.66793 12.1033H12.4828C13.2803 12.1033 13.6791 12.1033 13.7675 12.0377C13.8655 11.9651 13.8912 11.9187 13.9011 11.7972C13.9101 11.6874 13.6653 11.2939 13.1756 10.5069C12.595 9.57397 12.0754 8.16346 12.0754 6.10333Z"
              stroke="white"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_6952_954">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0.0751953 0.77002)"
              />
            </clipPath>
          </defs>
        </svg>
        <span>{{ multiLanguage.AvailabilityButton }}</span>
      </button>
      <recaptcha
        v-if="!!$ceres.config.global.googleRecaptchaApiKey && loadRecaptcha"
      ></recaptcha>
    </form>
  </div>
</template>

<script>
import NotificationService from "../../services/NotificationService";
import TranslationService from "../../services/TranslationService";
import ValidationService from "../../services/ValidationService";
import { executeReCaptcha } from "../../helper/executeReCaptcha";
import { mapState } from "vuex";

export default {
  name: "availability-request",
  inject: {
    itemId: {
      default: null,
    },
  },
  props: {
    multiLanguage: Object,
  },
  data() {
    return {
      phone: "",
      email: "",
      message:
        "Verfügbarkeitsanfrage für die Artikel id: " +
        this.itemId +
        "\nWann wird dieser Artikel verfügbar sein?",
      isDisabled: true,
      privacyPolicyValue: true,
      honeypot: "",
      loadRecaptcha: true,
      emailFolder: 39,
    };
  },

  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),
    currentVariation() {
      return this.$store.getters[`${this.itemId}/currentItemVariation`];
    },
    tooltipText() {
      if (this.hasAvailableVariations) {
        return this.$translate(
          "Ceres::Template.singleItemPleaseSelectValidVariation"
        );
      } else {
        return this.$translate(
          "Ceres::Template.singleItemPleaseSelectNotAvailable"
        );
      }
    },
  },

  methods: {
    validateData() {
      this.isDisabled = true;

      ValidationService.validate($("#ask-question-avability-form_" + this._uid))
        .done(() => {
          this.save();
        })
        .fail((invalidFields) => {
          ValidationService.markInvalidFields(invalidFields, "error");

          this.isDisabled = false;
        });
    },

    save() {
      executeReCaptcha(this.$el).then((recaptchaToken) => {
        fetch("https://dashboard.dubinu.com/v1/events/create/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            plenty_user_id: this.userData ? this.userData.id : null,
            event: "cart.ask_availability",
            host: window.location.host,
            payload: {
              fullName: this.userData ? this.userData.fullName : null,
              phone: this.phone,
              email: this.email,
              article_id: this.currentVariation.variation.id,
              article_number: this.currentVariation.variation.number,
            },
            recaptchaToken: recaptchaToken,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then(() => {
            NotificationService.success(
              TranslationService.translate("Ceres::Template.contactSendSuccess")
            ).closeAfter(3000);
            this.resetInputs();
            this.resetRecaptcha();
          })
          .catch((error) => {
            console.error(
              "There was a problem with the fetch operation:",
              error
            );
            NotificationService.error(
              TranslationService.translate("Ceres::Template.contactSendFail")
            ).closeAfter(5000);
            this.resetRecaptcha();
          });
      });
    },

    resetInputs() {
      this.phone = "";
      this.email = "";
      this.message = "";
      this.privacyPolicyValue = false;
    },

    resetRecaptcha() {
      if (App.config.global.googleRecaptchaVersion === 2 && window.grecaptcha) {
        const recaptchaId = this.$el.querySelector("[data-recaptcha]");
        window.grecaptcha.reset(recaptchaId);
      }
    },

    validateInputs() {
      this.isDisabled = !this.email.trim();
    },
  },

  watch: {
    email: "validateInputs",
  },
};
</script>
